import { Return } from "../Components";

export const Reason = () => {
  return <Return />;
};
